import type { MarkPrompt } from 'containers/admin/clients/client/tabs-components/ai-assistant/mark-panel/mark-panel.types';

import { MONITORING_PROMPT_CATALOG } from 'containers/user/critical-elements-monitoring/mark/monitoring-mark-prompt-catalog';
import type {
  MonitoringPromptCard,
  MonitoringPromptScope,
  MonitoringPromptView,
} from 'containers/user/critical-elements-monitoring/mark/monitoring-mark-prompt-catalog';
import type { StageDisplayMode } from 'containers/user/critical-elements-monitoring/monitoring-constants';
import type { CompareTo } from 'containers/user/critical-elements-monitoring/critical-elements-monitoring.types';

const MAX_PROMPTS = 3;

const FALLBACK_COMPARE_TO: CompareTo = 'point-in-time';

export interface MonitoringPromptQuery {
  scope: MonitoringPromptScope;
  compareTo: CompareTo;
  displayMode: StageDisplayMode;
  card: MonitoringPromptCard;
}

const matchesView = (
  entryView: MonitoringPromptView,
  displayMode: StageDisplayMode
): boolean => {
  if (entryView === 'any') return true;
  if (entryView === displayMode) return true;

  return displayMode === 'proportion' && entryView === 'volume';
};

export const getMonitoringPrompts = ({
  scope,
  compareTo,
  displayMode,
  card,
}: MonitoringPromptQuery): MarkPrompt[] => {
  const candidates = MONITORING_PROMPT_CATALOG.filter(
    (entry) =>
      entry.scope === scope &&
      entry.card === card &&
      matchesView(entry.view, displayMode)
  );

  const exactMatches = candidates.filter(
    (entry) => entry.compareTo === compareTo
  );
  const matches = exactMatches.length
    ? exactMatches
    : candidates.filter((entry) => entry.compareTo === FALLBACK_COMPARE_TO);

  return matches
    .slice(0, MAX_PROMPTS)
    .map((entry) => ({ id: entry.id, text: entry.text }));
};
